import React from "react";
import { SxProps, Theme, Typography as MUITypography } from "@mui/material";

interface TypographyProps {
  children: string | React.ReactNode;
  variant?:
    | "body1"
    | "body2"
    | "button"
    | "caption"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "inherit"
    | "overline"
    | "subtitle1"
    | "subtitle2";
  align?: "inherit" | "center" | "left" | "right";
  style?: React.CSSProperties;
  // Breakpoint-aware styling; `style` is inline and would beat it, so a value
  // set here must not also be set in `style`.
  sx?: SxProps<Theme>;
  color?: "error";
  component?: "li";
  noWrap?: boolean;
}

const Typography: React.FC<TypographyProps> = ({
  children,
  variant = "body1",
  color,
  align = "left",
  style = {},
  sx,
  component = null,
  noWrap = false,
}) => {
  return (
    <MUITypography
      {...(color ? { color } : {})}
      variant={variant}
      {...(component ? { component } : {})}
      align={align}
      style={style}
      sx={sx}
      noWrap={noWrap}
    >
      {children}
    </MUITypography>
  );
};

export default Typography;
